import { render, staticRenderFns } from "./AirCancelled.vue?vue&type=template&id=2f9bc2d8&"
import script from "./AirCancelled.vue?vue&type=script&lang=js&"
export * from "./AirCancelled.vue?vue&type=script&lang=js&"
import style0 from "./AirCancelled.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports